import TableCard from 'components/organisms/Admin/Permission/TableCard'
import React from 'react'

const Permission: React.VFC = () => {
  return <TableCard />
}

export default Permission
